import { useState } from 'react';
import Avatar, { Size, Status } from 'components/base/Avatar';
import classNames from 'classnames';

interface AvatarUploadProps {
  size: Size;
  src: string;
  className?: string;
  status?: Status;
  thumbnail?: boolean;
  onChange?: () => void;
  imageClassName?: string;
  onError?: (event: React.SyntheticEvent<HTMLImageElement, Event>) => void;
}

const AvatarUpload = ({
  size,
  src,
  status,
  thumbnail,
  className,
  imageClassName,
  onError
}: AvatarUploadProps) => {
  const [image] = useState<File | null>(null);

  return (
    <div className={classNames('d-inline-flex', className)}>
      <label htmlFor="avatarFile">
        <Avatar
          size={size}
          status={status}
          src={image ? URL.createObjectURL(image) : src}
          thumbnail={thumbnail}
          imageClassName={imageClassName}
          onError={onError}
        />
      </label>
    </div>
  );
};

export default AvatarUpload;
